<template>
  <div>
    <search-form @search="onSearch" :fields="['name', 'phone', 'email']"/>
    <div class="margin-top-2" v-if="showResult">
      <contacts-table        
        :contacts="contactRecords"
        :show-search-empty-state="!uiFlags.contact.isFetching && contactRecords.length === 0"
        :is-loading="uiFlags.contact.isFetching"
        :on-click-contact="redirectContact"
        :show-column-account="isAccountTypeParent"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { frontendURL } from 'dashboard/helper/URLHelper';

import ContactsTable from '../../../routes/dashboard/contacts/components/ContactsTable.vue';
import SearchForm from './SearchForm';

export default {
  components: {    
    ContactsTable,
    SearchForm
  },
  data() {
    return {      
      showResult: false
    };
  },  
  computed: {
    ...mapGetters({
      contactRecords: 'conversationSearch/getContactRecords',
      uiFlags: 'conversationSearch/getUIFlags',
      isAccountTypeParent: 'isAccountTypeParent',
    }),    
  },  
  methods: {
    onSearch(data) {
      this.showResult = data !== null;
      if(!data || Object.keys(data).length == 0){
        this.$store.dispatch('conversationSearch/clearSearchResults', { type: 'contact' });
        return;
      }      
      this.$store.dispatch('conversationSearch/contactSearch', {
        name: data.name,
        phone: data.phone,
        email: data.email,
        subaccount: data.subaccount ? data.subaccount.id : null
      });
    },
    redirectContact(contact) {
      const url = frontendURL(`accounts/${contact.account.id}/contacts/${contact.id}`);
      if(this.$route.params.accountId != contact.account.id){
        window.location.href = url;
        return;
      }
      this.$router.push(url);      
    },
  },
};
</script>


